export default "__VITE_ASSET__Dcrpq0GB__"